import React, { useEffect, useState } from 'react';
import ConfigTarget from '../ConfigTarget';
import { NodeConfigData } from '../../../../connector/connector-form/interfaces/nodeFormData';
import { TargetType, TargetTypesEnum } from '../../models/target-type';
import { SettingsFormSubmissionMode } from '../../../../connector/connector-form/interfaces/submissionMode';
import { getErrorMessageFromObj } from '../../../../core/utils/request';

interface TargetSettingsFormProps {
  targetData: NodeConfigData;
  savedTargetName: string;

  targetTypeIdentifier: TargetTypesEnum;
  targetTypeMetaData: TargetType;

  updateConnection: boolean;

  formError: any;
  formErrorCode: number;
  formErrorFor: SettingsFormSubmissionMode;

  formSuccess: any;

  connecting: boolean;
  submitting: boolean;

  testBtnText: string;
  submitBtnText: string;
  canShowSubmissionOverlay: boolean;

  formErrorClick: Function;
  testConnectionClick: Function;
  testConnectionFormErrored: (e: any) => void;
  testConnection: Function;
  continueClick: Function;
  continueFormErrored: (e: string[]) => void;
  continue: Function;
  markFormDirty: Function;
  setFormSuccess: (e: any) => void;
}

function TargetSettingsForm({
  targetData,
  savedTargetName,

  targetTypeIdentifier,
  targetTypeMetaData,

  updateConnection,

  formError,
  formErrorCode,
  formErrorFor,

  formSuccess,

  connecting,
  submitting,

  testBtnText,
  submitBtnText,
  canShowSubmissionOverlay,

  formErrorClick,
  testConnectionClick,
  testConnectionFormErrored,
  testConnection,
  continueClick,
  continueFormErrored,
  continue: onContinue,
  markFormDirty,
  setFormSuccess,
}: TargetSettingsFormProps) {

  const [hasViewLoaded, setHasViewLoaded] = useState(false);

  useEffect(() => {
    targetData && setHasViewLoaded(true);
  }, [targetData, formError, submitBtnText, testBtnText, formSuccess]);

  const applyFormUpdates = (formData) => {
    if (targetData) {
      targetData.formData = formData;
    }
  };

  const formErrorMessage = () => {
    return formError ? getErrorMessageFromObj(formError) : '';
  };

  return (
    hasViewLoaded ?
      <ConfigTarget
        formData={targetData?.formData}
        formMetaData={targetData?.metaData}
        targetTypeIdentifier={targetTypeIdentifier}
        targetTypeMetaData={targetTypeMetaData}
        savedTargetName={savedTargetName}
        formError={formErrorMessage()}
        formSuccess={formSuccess}
        submitBtnText={submitBtnText}
        testBtnText={testBtnText}
        submitting={submitting}
        connecting={connecting}
        canShowSubmissionOverlay={canShowSubmissionOverlay}
        onFormChanges={applyFormUpdates}
        onContinueClick={continueClick}
        onContinueFormError={continueFormErrored}
        onTestConnectionFormError={testConnectionFormErrored}
        onTestConnectionClick={testConnectionClick}
        onTestConnection={testConnection}
        onContinue={onContinue}
        markFormDirty={markFormDirty}
        isEditing={updateConnection}
        setFormSuccess={setFormSuccess}
        formErrorCode={formErrorCode}
        formErrorClick={formErrorClick}
      />
      :
      null
  );
}

export default TargetSettingsForm;
